import React, { useState, useEffect } from "react";
import './App.css';
import HeroSection from './components/HeroSection';
import RecruiterSection from './components/RecruiterSection';
import ServicesSection from './components/ServicesSection';
import ScrollToTopButton from './components/ScrollToTopButton';
import './components/ScrollToTopButton.css';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import './i18n';
import { useTranslation } from 'react-i18next';
import FranceFlag from './assets/flags/Flag_of_France.svg';
import GermanyFlag from './assets/flags/Flag_of_Germany.svg';
import Logo from './assets/Logo/logo.png';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();

  // --- SEO: Dynamic title and meta description ---
  useEffect(() => {
    document.title = "ProConnet TN";
  }, []);

  useEffect(() => {
    let desc = '';
    if (i18n.language === 'de') {
      desc = 'ProConnet TN – Ihr Partner für qualifizierte Personal-Lösungen. Wir verbinden tunesische Fachkräfte mit deutschen Gesundheitseinrichtungen.';
    } else {
      desc = 'ProConnet TN – Votre partenaire pour des solutions de personnel qualifié. Nous connectons les professionnels tunisiens aux établissements de santé allemands.';
    }
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = desc;
  }, [i18n.language]);

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="App">
      {/* SEO: Main heading for Google */}
      <h1 style={{display: 'none'}}>ProConnet TN - Solutions de recrutement Tunisie Allemagne</h1>
      <header className="navbar">
        <div className="logo">
          <img
            src={Logo}
            alt="ProConnet Logo"
            className="navbar-logo-img"
            style={{ width: "120px", maxWidth: "160px", height: "auto" }}
          />
        </div>
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <a href="#hero" onClick={() => setMenuOpen(false)}>{t('home')}</a>
          <a href="#recruiter-section" onClick={e => { e.preventDefault(); document.getElementById('recruiter-section')?.scrollIntoView({ behavior: 'smooth' }); setMenuOpen(false); }}>{t('recruiter_nav')}</a>
          <a href="#support" onClick={() => setMenuOpen(false)}>{t('candidate_nav')}</a>
          <a href="#about" onClick={() => setMenuOpen(false)}>{t('about_nav')}</a>
        </nav>
        <div className="navbar-actions">
          <button className="consult-btn" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>{t('contact')}</button>
          <div className="lang-switcher">
            <button
              className={i18n.language === 'fr' ? 'lang-btn active' : 'lang-btn'}
              onClick={() => handleLanguageChange('fr')}
              aria-label="Switch to French"
            >
              <img src={FranceFlag} alt="French" style={{ width: 24, height: 16, verticalAlign: 'middle' }} />
            </button>
            <button
              className={i18n.language === 'de' ? 'lang-btn active' : 'lang-btn'}
              onClick={() => handleLanguageChange('de')}
              aria-label="Switch to German"
            >
              <img src={GermanyFlag} alt="German" style={{ width: 24, height: 16, verticalAlign: 'middle' }} />
            </button>
          </div>
        </div>
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </header>

      <HeroSection />
      <RecruiterSection id="recruiter-section" />
      <ServicesSection />
      <AboutSection />
      <ContactSection id="contact" />

      <ScrollToTopButton />
      <Footer />
    </div>
  );
}

export default App;